import { ConvertCurrency } from "@src/pages/convert/classes/ConvertProcess"

interface Balance {
  balances: {
    available: string
    pending: string
    posted: string
  }
  network: string
  symbol: string
}

export const getBalance = (
  balances: Array<Balance & { decimals?: number; token_kind?: null | string }>,
  { network, symbol }: ConvertCurrency,
) => {
  const balance = balances.find(
    (balance) => balance.symbol === symbol && balance.network === network,
  )

  return { balance: balance?.balances.available, decimals: balance?.decimals }
}
